import { format } from 'date-fns'
import React, { ReactElement } from 'react'
import { useDayMonthFormat } from '@hooks/useDayMonthFormat'
import { Availabilities } from '@customTypes/Availabilities'
import { useDateFnsLocale } from '@hooks/useDateFnsLocale'
import { SlotsUseStylesProps } from '../Slots/Slots.styles'
import useStyles from './PeriodDays.styles'
import { GoBackArrow } from '../Navigation/GoBackArrow'
import { GoNextArrow } from '../Navigation/GoNextArrow'
import { AppMode } from '@customTypes/Generic'
import { useConfig } from '@context/ConfigurationContext'
import clsx from 'clsx'
import { useAppointmentCalendar } from '@context/AppointmentCalendarContext/AppointmentCalendarContext'
import { useSwipeAppointmentCalendar } from '@hooks/useSwipeAppointmentCalendar'
import { first, last } from 'lodash'
import { useIsPhoneOnly } from 'src/config/mediaQueries'

type WeekDaysProps = SlotsUseStylesProps & {
  currentWeek: Availabilities[]
}

const PeriodDays = ({ currentWeek, variant = 'default' }: WeekDaysProps): ReactElement => {
  const locale = useDateFnsLocale()
  const classes = useStyles({ variant })
  const dayMonthFormatWeekDays = useDayMonthFormat()
  const dayMonthFormatPeriod = useDayMonthFormat(4)
  const { mode } = useConfig()
  const isGapFiller = mode === AppMode.GAP_FILLER
  const { isMoreClinicsOpen } = useAppointmentCalendar()
  const isMobile = useIsPhoneOnly();

  const getFormatedDayOfPeriod = (date: string | number): string =>
    format(new Date(date), dayMonthFormatPeriod, { locale })
  const firstDayOfTheWeek = first(currentWeek)?.date || 0
  const lastDayOfTheWeek = last(currentWeek)?.date || 0

  const shouldDisplaySwipeAppointmentCalendar = useSwipeAppointmentCalendar();
  const isMobileSwipeArrowVisible = !(shouldDisplaySwipeAppointmentCalendar && isMobile);

  return (
    <>
      {!isGapFiller && isMobileSwipeArrowVisible && (
        <div className={classes.periodRange}>{`${getFormatedDayOfPeriod(firstDayOfTheWeek)} - ${getFormatedDayOfPeriod(
          lastDayOfTheWeek
        )}`}</div>
      )}
      <div className={clsx(classes.root, { [classes.multipleClinicsRoot]: isMoreClinicsOpen })}>
        {!isGapFiller && isMobileSwipeArrowVisible && (
          <>
            <GoBackArrow />
            <GoNextArrow />
          </>
        )}

        {(currentWeek || []).map((day) => {
          const dayDate = new Date(day.date)
          return (
            <div className={classes.weekDay} key={day.date}>
              <div className={classes.weekDayName}>{format(dayDate, 'EEE', { locale })}</div>
              <div className={classes.weekDayDate}>{format(dayDate, dayMonthFormatWeekDays, { locale })}</div>
            </div>
          )
        })}
      </div>
    </>
  )
}

export default PeriodDays
